import { baseClasses } from '@weatherbug/common';

import { EmUserProfile, PulseBaseOptions, PulseBaseLogger } from '../../components/common/interfaces/types';
const { PulseBaseProvider } = baseClasses;

const _authLoginURI = '/api/auth/success';

function authLoginValidationFunction(response: EmUserProfile) {
    return response?.Locations && response?.Settings && response?.UserInfo;
}

export class AuthProvider extends PulseBaseProvider {
    constructor(baseUrl?: string, authId?: string, secret?: string, options?: PulseBaseOptions, logger?: PulseBaseLogger) {
        super(baseUrl, authId, secret, options, logger);
    }

    async login(accessToken: string, refreshToken: string): Promise<EmUserProfile> {
        const queryParams = {
            accessToken,
            refreshToken
        };

        return await super.postData(queryParams, null, _authLoginURI, true, authLoginValidationFunction, false);
    }
}
